<template>
    <div class='spaceCenter common common-form-inline'>
        <a-form-model
        ref="ruleForm"
        :model="pageData"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 13 }"
        :rules="rules"
        >
            <a-form-model-item label="账户名称" prop="cstNm">
                {{params.recvAccNm}}
            </a-form-model-item>
            <a-form-model-item label="账 户 号 " prop="accNo">
                {{params.recvAccNo}}
            </a-form-model-item>
            <a-form-model-item label="开户银行" prop="account">
                {{params.recvBankNm}}
            </a-form-model-item>
            <a-form-model-item label="提现金额" prop="amount">
                <user-currency :value="params.amount" class="text-size-20 text-color-orange"></user-currency> 元
            </a-form-model-item>
            <a-form-model-item label="提现密码" prop="txnPwd">
                <a-input v-model="pageData.txnPwd" type="password"></a-input>
            </a-form-model-item>
        </a-form-model>
    </div>
</template>

<script>
import userCurrency from "@/components/user-currency/user-currency";
import {withdraw} from "@/api/withdraw.js"
import {mapGetters} from "vuex"
export default {
    props:["params"],
    name:"confirmInfo",
    components:{
        userCurrency
    },
    data() {
        return {
            pageData:{
                txnPwd:undefined
            },
            rules:{
                txnPwd:{
                    required: true,
                    trigger: "blur",
                    whitespace:true,
                    message:"请填写提现密码"
                },
                
            }
        };
    },
    computed: {
        ...mapGetters({
            userObj: "home/getUserObj",
        })
    },
    methods: {
        check(){
            return new Promise((resolve,reject) => {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        const params = {
                            recvAccNm: this.params.recvAccNm,
                            recvBankNm: this.params.recvBankNm,
                            recvAccNo: this.params.recvAccNo,
                            amount: this.params.amount,
                            recvTgfi:this.params.recvTgfi,
                            txnPwd: this.utils.getPasswordEncryptString(this.pageData.txnPwd),
                        };
                        withdraw(params,true).then(res => {
                            resolve(res);
                        }).catch(err => {
                            this.errMsg = err.description;
                            reject(err);
                        })
                
                    } else {
                        return false;
                    }
                });
            })   
        }
    },
    created() {
    },
    mounted() {},
    watch: {}
}
</script>
<style scoped>
.common-form-inline{
    margin: 40px 0;
}
.input-box{
    position: relative;
}
.input-btn{
    position: absolute;
    right: 5px;
    top: 8px;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/pages/withdraw/confirmInfo.vue